import React from "react"
import { Skeleton } from "@walmart-web/livingdesign-components"
import "./SwitchingSankeyContainerSkeleton.styles.scss"
import withVisibility from "components/Shared/Hocs/withVisibility"

const SwitchingSankeyContainerSkeleton = () => {
	return (
		<div className="sankey-card-sk">
			<div className="title">
				<Skeleton height="2rem" width="400px" />
			</div>
			<div className="sankeys">
				<div className="sankey">
					<div className="sankey-header">
						<Skeleton height={60} width={200} />
						<Skeleton height="2rem" width={400} />
					</div>
					<Skeleton height={300} />
				</div>
				<div className="sankey">
					<div className="sankey-header">
						<Skeleton height="2rem" width={400} />
						<Skeleton height={60} width={200} />
					</div>
					<Skeleton height={300} />
				</div>
			</div>
			<p className="total">
				<Skeleton height="2rem" width={300} />
			</p>
		</div>
	)
}

export default withVisibility(SwitchingSankeyContainerSkeleton)
